/* eslint-disable @angular-eslint/directive-selector */
import { Directive, ElementRef, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { NgIf } from '@angular/common';
import { FeatureService } from '@shared/services/feature.service';

// <div *showIfHasFeature="{apps: ['Ticketing', 'Knowledge']"> || Returns true only if any of the app matches to be enabled/visible
// <div *showIfHasFeature="{app: 'Ticketing'}"> || Returns true if app matches to be enabled/visible
// <div *showIfHasFeature="{feature: 'header.accountDropdown'}">

// <div *showIfHasFeature="{featureWithinApp: 'ticketing.accountDropdown'}">

@Directive({
  selector: '[showIfHasFeature]'
})
export class ShowIfHasFeatureDirective {
  private readonly ngIfDirective: NgIf;

  @Input()
  public set showIfHasFeature(featureOrApp: any) {
    this.ngIfDirective.ngIf = this.featureService.isFeatureEnabled(featureOrApp);
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private featureService: FeatureService
  ) {
    if (!this.ngIfDirective) {
      this.ngIfDirective = new NgIf(this.viewContainer, this.templateRef);
    }
  }
}
